import React from 'react';

import config from '@shared/config';

import logo from '/logo.png';

export const Logo: React.FC<any> = ({ color, icon, ...props }) => {
  return (
    // <Typography variant="subtitle2" component="div" bgcolor="primary.main" color="common.white" fontWeight={900} fontSize={18}>{config.projectName}</Typography>
    <img {...props} src={logo} alt={config.projectName}/>
  );
};
